import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify"; // Import ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Import Toastify styles
import Shop from "./Pages/Shop";
import ShopCategory from "./Pages/ShopCategory";
import Product from "./Pages/Product";
import Cart from "./Pages/Cart";
import LoginSignup from "./Pages/LoginSignup";
import Footer from "./Components/Footer/Footer";
import Checkout from "./Pages/Checkout";
import Consultation from "./Pages/Consultation";
import Orders from "./Pages/Orders";
import Profile from "./Components/Profile/Profile";
import EditProfile from "./Components/Profile/EditProfile";
import Wishlist from "./Components/Wishlist/Wishlist";
import AboutUs from "./Components/AboutUs/AboutUs";
import RefundPolicy from "./Components/RefundPolicy/RefundPolicy";
import Conditions from "./Components/Conditions/Conditions";
import FAQ from "./Components/FAQ/FAQ";
import ProductList from "./Components/ProductList/ProductList";
import { useAuthRefresh } from "./hooks/useAuthRefresh"; 
import { useInventorySync } from "./hooks/useInventorySync";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import ResetPassword from "./Components/ResetPassword/ResetPassword";
import BridalPage from "./Pages/BridalPage";
import SeoManager from "./Components/SeoManager";

function App() {

  // ✅ Call the token refresh hook here 

  useAuthRefresh(); 
  useInventorySync();
  
  return (
    <div>
      <BrowserRouter>
      <SeoManager />
      <ToastContainer /> {/* Add ToastContainer here */}
        <Navbar />

        <Routes>
          <Route path="/" element={<Shop />} />
          <Route
            path="/new"
            element={<ShopCategory  category="new" />}
          />
          <Route
            path="/co-ords"
            element={<ShopCategory  category="co-ords" />}
          />
          <Route
            path="/dresses"
            element={<ShopCategory  category="dresses" />}
          />
         
          <Route path="/profile" element={<Profile />} />
          <Route path="/editprofile" element={<EditProfile />} />
          {/* <Route path="/product" element={<Product />}>
            <Route path=":productId" element={<Product />} />
          </Route> */}
          <Route path="/product/:productId" element={<Product />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/login" element={<LoginSignup />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/conditions" element={<Conditions />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/product" element={<ProductList />} />
          <Route path="/bridal" element={<BridalPage />} />

        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
